import { createSelector } from '@reduxjs/toolkit';

import { selectContract } from 'shared/selectors/jsonQuery';

import { selectContractLabel } from './selectContractLabel';
import { selectContractOptions } from './selectContractOptions';

export const selectContractFilter = createSelector(
  [selectContract, selectContractLabel, selectContractOptions],
  (value, label, options) => ({
    label,
    value: value ?? [],
    options,
  }),
);
